import type { RegularizeSavedCard } from './types';

export const formatCardDisplayName = (card: RegularizeSavedCard): string =>
  `${card.brand ? card.brand.toUpperCase() : 'Cartão'} •••• ${
    card.last_digits
  } — ${card.expiration_date}`;

export const formatCardExpirationDisplay = (value: string): string => {
  if (!value) {
    return '';
  }

  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length <= 2) {
    return cleaned;
  }

  return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}`;
};

export const getSelectedCardLabel = (
  selectedCardId: string | 'new' | null,
  savedCards: RegularizeSavedCard[],
  showInUseInLabel: boolean,
): string => {
  if (!selectedCardId || selectedCardId === 'new') {
    return '+ Adicionar um novo cartão de crédito';
  }

  const card = savedCards.find((item) => item.id === selectedCardId);
  if (!card) {
    return 'Cartão';
  }

  const label = formatCardDisplayName(card);

  if (card.in_use && showInUseInLabel) {
    return `${label} · Em uso`;
  }

  return label;
};
